<template>
  <VLoader v-if="loading" />
  <section v-else class="shared-section">
    <div>
      <header class="shared-section-header">
        <h2 class="shared-section-header-heading">
          <router-link :to="{ name: 'post-training' }">
            {{ $t('postTraining.heading') }}
          </router-link>
        </h2>
        <span class="mx-4"><VSvgIcon name="chevron-double-right" /></span>
        <span class="font-bold">{{ product.display_name }}</span>
      </header>
    </div>
    <!-- DTG WARRANTY -->
    <WarrantyDtg
      v-if="isDtgProduct() && hasWarrantyOnTop"
      :hasNotReadWarranty="hasNotReadWarranty"
      @handleHasNotReadWarranty="changeHasNotReadWarranty"
    />
    <!-- container to make it fuzzy if the customer has not read the warranty -->
    <div class="relative">
      <div
        v-if="hasNotReadWarranty && isDtgProduct()"
        class="absolute left-0 top-0 w-full h-full opacity-50 z-50 text-opacity-50 cursor-not-allowed"
      ></div>
      <!-- DTG Extra Info -->
      <div v-if="isDtgProduct()" class="mb-8">
        <div>
          <h4 class="product-details-heading">{{ $t('postTraining.dtg.heat_press') }}</h4>
          <ul class="list-disc mt-4 ml-8" :class="[{ 'blurry-text': blurryText }]">
            <li>Light shirt (CMYK only): 356F/180C, 40 seconds</li>
            <li>Dark shirt (white ink): 330F/165C, 90 seconds</li>
          </ul>
        </div>
        <div class="mt-4">
          <h4 class="product-details-heading">{{ $t('postTraining.dtg.pre_treated') }}</h4>
          <div class="mt-4">
            <a
              class="text-ricoma-blue-100"
              :class="[{ 'blurry-text': blurryText }]"
              target="_blank"
              href="https://www.rtpapparel.com/"
              >https://www.rtpapparel.com/</a
            >
          </div>
        </div>
      </div>
      <!-- resources -->
      <div id="resources" v-if="!!resources.length" class="">
        <h4 class="product-details-heading">{{ $t('postTraining.resources.downloads') }}</h4>
        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
          :class="[{ 'blurry-text': blurryText }]"
        >
          <div
            v-for="resource in resources"
            :key="`resource-${resource.id}`"
            class="product-details-resource mr-12 text-center"
          >
            <a
              :href="resource.file_path || resource.link"
              target="_blank"
              class="product-details-resource-link"
            >
              <div class="product-details-resource-icon">
                <VSvgIcon name="download" width="50" height="50" class="text-white" />
              </div>
            </a>
            <h5 class="product-details-resource-heading">
              {{ `${$t('postTraining.resources.download')} ${resource.title}` }}
            </h5>
          </div>
        </div>
      </div>
      <!-- post traninig videos -->
      <div v-if="product.post_training_videos.data.length > 0" class="mb-4">
        <div class="product-details-heading-container">
          <h4 class="border-b-0 product-details-heading">
            {{ $t('postTraining.resources.videos') }}
          </h4>
        </div>
        <div class="product-details-videos" :class="[{ 'blurry-text': blurryText }]">
          <ProductDetailsVideo
            v-for="(video, index) in trainingVideos"
            :key="`vid-${index}`"
            :video="video"
          />
        </div>
      </div>
    </div>
    <!-- DTG WARRANTY -->
    <WarrantyDtg
      v-if="isDtgProduct() && !hasNotReadWarranty && !hasWarrantyOnTop"
      :hasNotReadWarranty="hasNotReadWarranty"
      @handleHasNotReadWarranty="changeHasNotReadWarranty"
    />
  </section>
</template>

<script>
import { mapState } from 'vuex';

import VSvgIcon from '@/components/base/VSvgIcon';
import VLoader from '@/components/base/VLoader';
import download from '@/assets/download.svg';
import { safeNullDataset, isDtg } from '@/utils';

import ProductDetailsVideo from '@/components/customer/ProductDetailsVideo';
import WarrantyDtg from '@/components/customer/WarrantyDtg';

export default {
  name: 'PostTrainingLessons',
  components: { ProductDetailsVideo, WarrantyDtg, VSvgIcon, VLoader },
  data() {
    return {
      loading: false,
      product: '',
      hasWarrantyOnTop: true,
    };
  },
  computed: {
    ...mapState({}),
    trainingVideos() {
      const videos = safeNullDataset(this.product)(['post_training_videos', 'data']);
      return videos;
    },
    resources() {
      return safeNullDataset(this.product)(['post_training_resources', 'data']);
    },
    hasNotReadWarranty() {
      return !this.product.has_read_warranty;
    },
    blurryText() {
      return this.isDtgProduct() && this.hasNotReadWarranty ? true : false;
    },
  },

  methods: {
    async getProduct() {
      this.loading = true;
      // set product
      this.product = await this.$store.dispatch('customer/getProduct', {
        productId: this.$route.params.id,
        includeVideos: true,
        includeResources: true,
      });
      this.loading = false;
      this.hasWarrantyOnTop = this.product.has_read_warranty ? false : true;
    },
    getResourceIcon(name) {
      const icons = { download: download };
      return icons[name.replace(/ /g, '-').toLowerCase()];
    },
    isDtgProduct() {
      return isDtg(this.product.display_name);
    },
    async changeHasNotReadWarranty() {
      if (this.product.has_read_warranty) return;
      await this.$http.put(`product/change-has-read-warranty`, {
        product_id: this.product.id,
        has_read_warranty: !this.product.has_read_warranty,
      });
      this.product.has_read_warranty = !this.product.has_read_warranty;
    },
  },
  created() {
    this.getProduct();
  },
};
</script>
